var _rect, _g, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaution(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 88,
    fill: "#F0F3F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_827_40342)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1818,
    transform: "translate(-675 -776)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -675,
    y: -696,
    width: 1440,
    height: 1738,
    fill: "#F5F6F9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -614.5,
    y: -389.5,
    width: 1310,
    height: 916,
    rx: 19.5,
    fill: "white",
    stroke: "#A7AABD"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_827_40342)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 40,
    r: 40,
    fill: "#FF6600"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 40,
    r: 39.5,
    stroke: "#FF6600"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M42.024 47.912L41.504 21.6H46.236L45.716 47.912H42.024ZM44 58.26C43.1333 58.26 42.4053 57.9827 41.816 57.428C41.2613 56.8387 40.984 56.128 40.984 55.296C40.984 54.464 41.2613 53.7707 41.816 53.216C42.4053 52.6267 43.1333 52.332 44 52.332C44.832 52.332 45.5253 52.6267 46.08 53.216C46.6693 53.7707 46.964 54.464 46.964 55.296C46.964 56.128 46.6693 56.8387 46.08 57.428C45.5253 57.9827 44.832 58.26 44 58.26Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.024 47.912L41.0242 47.9318L41.0436 48.912H42.024V47.912ZM41.504 21.6V20.6H40.484L40.5042 21.6198L41.504 21.6ZM46.236 21.6L47.2358 21.6198L47.256 20.6H46.236V21.6ZM45.716 47.912V48.912H46.6964L46.7158 47.9318L45.716 47.912ZM41.816 57.428L41.0878 58.1134L41.1086 58.1354L41.1306 58.1562L41.816 57.428ZM46.08 53.216L45.3518 53.9014L45.3726 53.9234L45.3946 53.9442L46.08 53.216ZM46.08 57.428L45.3729 56.7209L46.08 57.428ZM43.0238 47.8922L42.5038 21.5802L40.5042 21.6198L41.0242 47.9318L43.0238 47.8922ZM41.504 22.6H46.236V20.6H41.504V22.6ZM45.2362 21.5802L44.7162 47.8922L46.7158 47.9318L47.2358 21.6198L45.2362 21.5802ZM45.716 46.912H42.024V48.912H45.716V46.912ZM44 57.26C43.3683 57.26 42.8913 57.0668 42.5014 56.6998L41.1306 58.1562C41.9194 58.8986 42.8984 59.26 44 59.26V57.26ZM42.5442 56.7426C42.1695 56.3445 41.984 55.8812 41.984 55.296H39.984C39.984 56.3748 40.3532 57.3328 41.0878 58.1134L42.5442 56.7426ZM41.984 55.296C41.984 54.7114 42.1682 54.278 42.5231 53.9231L41.1089 52.5089C40.3544 53.2634 39.984 54.2166 39.984 55.296H41.984ZM42.5231 53.9231C42.9167 53.5295 43.3868 53.332 44 53.332V51.332C42.8799 51.332 41.8939 51.7238 41.1089 52.5089L42.5231 53.9231ZM44 53.332C44.565 53.332 44.992 53.5191 45.3518 53.9014L46.8082 52.5306C46.0587 51.7342 45.099 51.332 44 51.332V53.332ZM45.3946 53.9442C45.7769 54.304 45.964 54.731 45.964 55.296H47.964C47.964 54.197 47.5618 53.2374 46.7654 52.4878L45.3946 53.9442ZM45.964 55.296C45.964 55.8623 45.7751 56.3187 45.3729 56.7209L46.7871 58.1351C47.5636 57.3586 47.964 56.3937 47.964 55.296H45.964ZM45.3729 56.7209C45.018 57.0758 44.5846 57.26 44 57.26V59.26C45.0794 59.26 46.0326 58.8896 46.7871 58.1351L45.3729 56.7209Z",
    fill: "white"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -10897,
    y: -24864,
    width: 53660,
    height: 41487,
    stroke: "black",
    strokeWidth: 50
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_827_40342",
    x: 0,
    y: 0,
    width: 88,
    height: 88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.4 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_827_40342"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_827_40342",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_827_40342"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1818,
    fill: "white",
    transform: "translate(-675 -776)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaution);
export default __webpack_public_path__ + "static/media/caution.bac2db8513f27c401eb326aa1f926699.svg";
export { ForwardRef as ReactComponent };